import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage";
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces";
import {
    AudioArticlesRecommendationsAction,
    buildActionHref,
    formatDuration,
    ProcessedAudioArticlesRecommendationsItem,
    resolveImageSrc,
} from "../audioArticlesRecommendationsUtils";

export type { AudioArticlesRecommendationsAction };

interface AudioArticlesRecommendationsItemCardProps {
    item: ProcessedAudioArticlesRecommendationsItem;
    imagesDomain?: string;
    categoryIconFirst?: boolean;
    hideDate?: boolean;
    actions?: AudioArticlesRecommendationsAction[];
    useNativeActionLinks?: boolean;
    onCardClick?: (itemForPlayer: ProcessedAudioArticlesRecommendationsItem) => void;
    href?: string;
    children?: React.ReactNode;
}

const ACTION_CLASS: { [key in AudioArticlesRecommendationsAction]: string } = {
    youtube: "actionButtonYoutube",
    apple: "actionButtonApplePodcasts",
    spotify: "actionButtonSpotify",
    share: "actionButtonShare",
};

const ACTION_LABEL: { [key in AudioArticlesRecommendationsAction]: string } = {
    youtube: "youtube",
    apple: "apple podcasts",
    spotify: "spotify",
    share: "share",
};

export class AudioArticlesRecommendationsItemCard extends React.Component<AudioArticlesRecommendationsItemCardProps, {}> {
    private renderActionButton = (action: AudioArticlesRecommendationsAction) => {
        const { item, useNativeActionLinks } = this.props;
        const className = `actionButton ${ACTION_CLASS[action]}`;
       
            const itemId = item.id || item.articleId || "";
            const href = buildActionHref(action, itemId, item.categoryId, useNativeActionLinks);
            if(!useNativeActionLinks && action === "share") {
                return (
                    
                   <HyperLinkBuilder href={item.link} linkTarget={item.targetLink as LinkTargetProperties}>
                    <button className={className} aria-label={ACTION_LABEL[action]} type="button" />
                   </HyperLinkBuilder>
                );
            }
           else{ return (
                <a
                    key={action}
                    href={href}
                    className={className}
                    aria-label={ACTION_LABEL[action]}
                    target={action === "share" ? undefined : "_blank"}
                />
            )}
    };

    render() {
        const {
            item,
            imagesDomain,
            categoryIconFirst,
            hideDate,
            actions,
            onCardClick,
            href,
            children,
        } = this.props;

        const {
            imageUrl,
            categoryName,
            dateUpdatedOnSite,
            title,
            categoryIconSrc,
            categoryIcon,
        } = item;

        const hasDate = !hideDate && !!(dateUpdatedOnSite && typeof dateUpdatedOnSite === "string" && dateUpdatedOnSite.trim());
        const imageSrc = resolveImageSrc(imageUrl || "", imagesDomain || "");
        const resolvedCategoryIconSrc = resolveImageSrc(categoryIcon || categoryIconSrc || "", imagesDomain || "");
        const hasImage = !!imageSrc;
        const mediaDuration = item.hasVideo && item.videoData && item.videoData.duration
            ? item.videoData.duration
            : (item.duration || 0);
        const itemForPlayer: ProcessedAudioArticlesRecommendationsItem = {
            ...item,
            imageUrl: imageSrc || imageUrl || "",
            categoryIconSrc: resolvedCategoryIconSrc,
        };

        const categoryIconEl = (
            <SiteSimpleImage
                className="itemPodcastIcon"
                src={resolvedCategoryIconSrc}
                alt={categoryName || ""}
                onError={(e) => { (e.target as HTMLImageElement).style.visibility = "hidden"; }}
            />
        );
        const categoryNameEl = <span className="itemCategory">{categoryName}</span>;

        const content = (
            <>
                {children}
                <div className="itemImage">
                    {hasImage && <img src={imageSrc} alt="" />}
                    <span className="playIcon" aria-hidden="true" />
                </div>

                <div className="itemContent">
                    <div className="itemMetaRow">
                        <div className="itemCategoryWrap">
                            {categoryIconFirst ? categoryIconEl : null}
                            {categoryNameEl}
                            {!categoryIconFirst ? categoryIconEl : null}
                        </div>
                        <div className="itemMetaDateWrap">
                            {hasDate && <DateDisplay className="itemDate" date={dateUpdatedOnSite} isHiddenHourInYesterday={true} />}
                        </div>
                    </div>

                    <h4 className="itemTitle" dangerouslySetInnerHTML={{ __html: title }} />

                    <div className="itemFooter">
                        <span className="itemDuration">{formatDuration(mediaDuration)}</span>
                        {actions && actions.length > 0 && (
                            <div className="itemActions" onClick={(e) => e.stopPropagation()}>
                                {_.map(actions, (action: AudioArticlesRecommendationsAction) => this.renderActionButton(action))}
                            </div>
                        )}
                    </div>
                </div>
            </>
        );

        if (href) {
            return (
                <div className="itemCard">
                    <a className="nativePodcastLink" href={href} aria-hidden="true" tabIndex={-1} />
                    {content}
                </div>
            );
        }

        return (
            <div
                className="itemCard"
                onClick={onCardClick ? () => onCardClick(itemForPlayer) : undefined}
            >
                {content}
            </div>
        );
    }
}
